module.exports = __webpack_public_path__ + "static/assets/ad28625310fbc04a44f663c16270d474.png";